import React from 'react';
import ErrorPage from './CollegeLimitExceeded';

const SessionExpired: React.FC = () => {
  return <ErrorPage messageText="Session Expired! Please Login Again" showLogout />;
};

export default SessionExpired;
